export default function (data) {
  let self = this;
  self.profile = ko.observable();

  self.bindData = function(data) {
    let mapped_profile = ko.mapping.fromJS(data, {ignore: ['current_password','password','password_confirmation']});
    self.profile(mapped_profile);
  };

  self.initUI = function () {

  };

  const __construct = function(that) {
    console.log('constructor called for AccountSettingsOverviewVM');
    that.bindData(data);
  }(this);
}
